module.exports = __webpack_public_path__ + "img/12217_3.63da9f1d.png";